import { ReportState } from "../models/model";
import { reportConfigActions } from "../interface/reducerType";

const initialState = {
  interval_report_data: {},
  abandoned_call_report: {},
};
export const reportReducer = (
  state: ReportState = initialState,
  action: reportConfigActions
) => {
  switch (action.type) {
    case "INTERVAL_REPORT":
      return {
        ...state,
        interval_report_data: action.payload.interval_report_data,
      };
    case "ABANDONED_CALL_REPORT":
      return {
        ...state,
        abandoned_call_report: action.payload.abandoned_call_report,
      };
    case "DISPOSITION_STATUS":
      return {
        ...state,
        disposition_status_data: action.payload.disposition_status_data,
      };
    case "QUEUE_BASE_INBOUND_CALL":
      return {
        ...state,
        queue_base_inbound_reports: action.payload.queue_base_inbound_reports,
      };

    default:
      return state;
  }
};
